<template>
  <validation-form @on-submit="manageGroup">
    <div class="md-layout group-chat-modal">
      <div class="md-layout-item md-size-100 mb-4">
        <validation-field
          :validations="{ required: true, format: formatGroupName }"
          name="group name"
        >
          <label>{{ $t("chat_room.group_name") }}</label>
          <md-input
            required
            v-model.trim="groupChatName"
            :maxlength="100"
          ></md-input>
        </validation-field>
      </div>
      <div class="md-layout-item md-size-100">
        <p class="font-medium text-[#000] text-base">
          {{ $t("chat_room.select_member") }}
          <span class="text-[#F44336]">*</span>
        </p>
      </div>
      <div class="md-layout-item md-size-100 md-layout p-0">
        <div
          class="md-layout-item md-size-100 md-layout h-[100px]"
          v-for="(item, index) in selectMemberList"
          :key="index + 'selectMember'"
        >
          <div class="md-layout-item md-size-15 flex items-center p-0 pb-5">
            <md-checkbox v-model="item.isActive"
              >{{ $t(item.name.value) }}
            </md-checkbox>
          </div>
          <div class="md-layout-item md-size-30" v-if="item.isActive">
            <validation-field
              :validations="{ required: true }"
              :name="item.name.key + ' filter by'"
              v-if="item.hasSecondFilter"
            >
              <label>{{ $t("chat_room.filter_by") }}</label>
              <md-select v-model="item.firstFilterValue">
                <md-option
                  v-for="(itemFilter, idx) in item.firstFilterList"
                  :key="idx + index + 'firstFilter'"
                  :value="itemFilter.id"
                >
                  {{ $t(itemFilter.name) }}
                </md-option>
              </md-select>
            </validation-field>
            <validation-field
              v-else
              :validations="{ required: true }"
              :name="item.objectType"
              type="multi-select"
            >
              <template #default="{ errors }">
                <SecondFilterMultipleSelect
                  :required="true"
                  :labelSmall="true"
                  :label="item.label"
                  :defaultSelected="item.defaultValue"
                  :objectType="item.objectType"
                  v-model="item.firstFilterValue"
                >
                </SecondFilterMultipleSelect>
                <span class="md-error object-required"> {{ errors[0] }}</span>
              </template>
            </validation-field>
          </div>
          <div
            class="md-layout-item md-size-30"
            v-if="
              item.hasSecondFilter && item.isActive && item.firstFilterValue
            "
          >
            <validation-field
              :validations="{ required: true }"
              name="field"
              type="multi-select"
            >
              <template #default="{ errors }">
                <SecondFilterMultipleSelect
                  :required="true"
                  :labelSmall="true"
                  :label="selectLabel[item.firstFilterValue]"
                  :defaultSelected="item.defaultValue"
                  :objectType="item.firstFilterValue"
                  v-model="item.secondFilterValue"
                >
                </SecondFilterMultipleSelect>
                <span class="md-error object-required"> {{ errors[0] }}</span>
              </template>
            </validation-field>
          </div>
          <div
            class="md-layout-item md-size-25 flex items-center pb-5"
            v-if="item.isActive && item.firstFilterValue === 'class'"
          >
            <md-checkbox v-model="item.activeStatus">
              {{ $t("chat_room.active_status") }}
            </md-checkbox>
          </div>
        </div>
        <div class="md-layout-item md-size-100 h-6">
          <span class="object-required" v-if="!hasSelectedOption">{{
            this.$t("chat_room.select_required")
          }}</span>
        </div>
        <div class="md-layout-item md-size-100 text-center">
          <md-button class="md-raised mx-2" @click="closeModal"
            >{{ $t("common.cancel") }}
          </md-button>
          <md-button class="md-success mx-2" type="submit"
            >{{ type === "edit" ? $t("common.update") : $t("common.add_new") }}
          </md-button>
        </div>
      </div>
    </div>
  </validation-form>
</template>
<script>
import SecondFilterMultipleSelect from "./SecondFilterMultipleSelect";
import { mapGetters } from "vuex";
import { getId, Message } from "@/helpers/utils";
import { service_paths } from "../../../../constants/Services";
import i18n from "../../../../lang/i18n";

export default {
  components: {
    SecondFilterMultipleSelect
  },
  props: ["type", "data"],
  data() {
    return {
      groupChatName: "",
      formatGroupName: {
        valid: value => /^[a-zA-Z0-9 ]*$/.test(value.trim()),
        message: i18n.t("The group name can't contain special character")
      },
      hasSelectedOption: true,
      selectLabel: {
        class: "chat_room.class",
        term: "chat_room.term",
        grade: "chat_room.grade",
        program: "chat_room.program",
        student: "chat_room.student",
        family: "chat_room.family",
        teacher: "chat_room.teacher",
        role: "chat_room.role"
      },
      selectMemberList: [
        {
          name: {
            key: "student",
            value: "chat_room.student"
          },
          isActive: false,
          firstFilterList: [
            { id: "class", name: "common.class" },
            { id: "student", name: "communication.student_name_student_id" }
          ],
          firstFilterValue: "",
          secondFilterValue: [],
          defaultValue: [],
          hasSecondFilter: true,
          activeStatus: false
        },
        {
          name: {
            key: "family",
            value: "chat_room.family"
          },
          isActive: false,
          firstFilterList: [
            { id: "class", name: "survey.family_belong_class" },
            { id: "student", name: "survey.family_belong_student_name_id" },
            { id: "family", name: "survey.parent_name_username" }
          ],
          firstFilterValue: "",
          secondFilterValue: [],
          defaultValue: [],
          hasSecondFilter: true,
          activeStatus: false
        }
      ]
    };
  },
  created() {
    if (this.role[0] !== "Teacher") {
      this.selectMemberList.push(
        {
          name: {
            key: "teacher",
            value: "chat_room.teacher"
          },
          isActive: false,
          firstFilterList: [
            { id: "class", name: "survey.teacher_of_class" },
            { id: "term", name: "survey.teacher_of_class_belong_term" },
            { id: "teacher", name: "survey.teacher_name_staff_id" }
          ],
          firstFilterValue: "",
          secondFilterValue: [],
          defaultValue: [],
          hasSecondFilter: true,
          activeStatus: false
        },
        {
          objectType: "role",
          label: "chat_room.role",
          name: {
            key: "role",
            value: "chat_room.others_staff"
          },
          isActive: false,
          firstFilterList: [],
          firstFilterValue: [],
          hasSecondFilter: false,
          defaultValue: [],
          activeStatus: false
        }
      );
    }
    if (this.type === "edit") {
      this.fetchGroupInfo();
    }
  },
  computed: {
    ...mapGetters("user", ["role"]),
    isSelectedStudent() {
      return this.selectMemberList[0].isActive;
    },
    isSelectedFamily() {
      return this.selectMemberList[1].isActive;
    },
    isSelectedTeacher() {
      return this.selectMemberList[2] ? this.selectMemberList[2].isActive : "";
    },
    isSelectedStaff() {
      return this.selectMemberList[3] ? this.selectMemberList[3].isActive : "";
    }
  },
  methods: {
    fetchGroupInfo() {
      this.$axios
        .get(`${service_paths.chat}/group/${this.data.id}`)
        .then(res => {
          this.groupChatName = res.data.name;
          let memberSetting = res.data.chat_room_no_sql.member_setting;
          for (let i = 0; i < memberSetting.length; i++) {
            this.selectMemberList.forEach(item => {
              if (item.name.key === memberSetting[i].name) {
                item.isActive = true;
                item.activeStatus = memberSetting[i].active;
                item.firstFilterValue = memberSetting[i].filter_by;
              }
            });
          }
          this.selectMemberList.forEach(item => {
            item.defaultValue =
              res.data.chat_room_no_sql.members[item.name.key];
            if (item.hasSecondFilter) {
              item.secondFilterValue = item.defaultValue;
            } else {
              item.firstFilterValue = item.defaultValue;
            }
          });
        });
    },
    manageGroup() {
      let member = this.selectMemberList
        .filter(item => item.isActive)
        .map(item => {
          if (item.hasSecondFilter) {
            return {
              name: item.name.key,
              filter_by: item.firstFilterValue,
              member_selected: item.secondFilterValue.map(item => getId(item)),
              active: item.activeStatus
            };
          } else {
            return {
              name: item.name.key,
              filter_by: item.firstFilterValue.map(item => item.id),
              active: item.activeStatus
            };
          }
        });
      if (member.length) {
        this.hasSelectedOption = true;
        let params = {
          group_name: this.groupChatName,
          selected_list: member
        };
        if (this.checkVietnameseString(params.group_name)) {
          Message.error(this.$t("chat_room.group_name_invalid"));
          return;
        }
        if (this.type === "add") {
          this.$axios.post(`${service_paths.chat}/group`, params).then(res => {
            Message.success(this.$t("chat_room.add_group_success"));
            this.$emit("reloadGroup");
          });
        }
        if (this.type === "edit") {
          this.$axios
            .put(`${service_paths.chat}/group/${this.data.id}`, params)
            .then(res => {
              Message.success(this.$t("common.update_success"));
              this.$emit("reloadGroup", this.groupChatName);
            });
        }
      } else {
        this.hasSelectedOption = false;
      }
    },
    checkVietnameseString(str) {
      if (str === null || str === undefined) return str;
      str = str.toLowerCase();
      let originString = str;
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
      str = str.replace(/đ/g, "d");
      return str !== originString;
    },
    closeModal() {
      this.$emit("closeModal");
    },
    refreshData(value, index) {
      if (!value) {
        this.selectMemberList[index].firstFilterValue = "";
        this.selectMemberList[index].secondFilterValue = [];
      } else {
        this.hasSelectedOption = true;
      }
    }
  },
  watch: {
    isSelectedStudent(value) {
      this.refreshData(value, 0);
    },
    isSelectedFamily(value) {
      this.refreshData(value, 1);
    },
    isSelectedTeacher(value) {
      this.refreshData(value, 2);
    },
    isSelectedStaff(value) {
      if (!value) {
        this.selectMemberList[3].firstFilterValue = "";
      } else {
        this.hasSelectedOption = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.object-required {
  color: #ff1744;
  font-size: 12px;
  top: -3px !important;
  position: relative;
}
</style>
